<template>
  <div>
    <table>
      <thead>
        <tr>
          <th v-for="(header, index) in headers" :key="index">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="index">
          <td v-for="(cell, idx) in row" :key="idx">
            {{ cell }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {

  props: {
    csvData: {
      type: String, // Define the expected type, e.g., String, Number, Array, etc.
    }
  },
  computed: {
    headers() {
      // Assuming the first line of csvData is the header
      return this.csvData.split('\n')[0].split(',');
    },
    rows() {
      const lines = this.csvData.trim().split('\n');
      lines.shift(); // Remove the header
      return lines.map(line => line.split(','));
    }
  }
};
</script>

<style>
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}
th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
thead {
  background-color: #f2f2f2;
}
</style>